import React from 'react';
import PropTypes from 'prop-types';
import { FaUpload } from 'react-icons/fa';

import { CtaButton } from '../../../../../styles/ui/Button';
import { IntroCard, IntroIcon, IntroTitle, IntroText } from './styles';

// ===========================================================================
// BatchIntro — estado vazio da aba (nenhuma planilha analisada ainda). O botão
// "Importar planilha" ABRE o modal de upload (não escreve no banco → CTA escuro
// por FC7, não azul). Alternativa: o + de uma célula do catálogo (Slice 2).
// ===========================================================================
export default function BatchIntro({ onImport }) {
   return (
      <IntroCard>
         <IntroIcon>
            <FaUpload size={26} />
         </IntroIcon>
         <IntroTitle>Importe uma planilha do Refiltek</IntroTitle>
         <IntroText>
            Envie a planilha .xlsx do Refiltek para uma data e período. Os itens
            entram no rascunho da roteirização correspondente, prontos para
            revisão antes de confirmar.
         </IntroText>
         <CtaButton type="button" onClick={onImport}>
            <FaUpload size={15} /> Importar planilha
         </CtaButton>
      </IntroCard>
   );
}

BatchIntro.propTypes = {
   onImport: PropTypes.func.isRequired,
};
